import {
  Box,
  Heading,
  Text,
  Image,
  VStack,
  HStack,
  Stack,
  SimpleGrid,
  Button,
  GridItem,
  
  Grid,

} from "@chakra-ui/react";
import { motion  } from "framer-motion";
import { useNavigate } from "react-router-dom";


const MotionBox = motion(Box);

export const AboutUs = () => {

  const MotionImage = motion(Image);
 
 const navigate=useNavigate();
  return (
    <Box bg="gray.50" py={0}>
      {/* Hero Section */}
    <Box
  position="relative"
  h="500px"
  bgImage="url('/2.png')"
  bgSize="cover"
  bgPosition="center"
  display="flex"
  alignItems="center"
  justifyContent="center"
  mb={10}
>
  {/* Overlay */}
  <Box position="absolute" inset={0} bg="blackAlpha.400" />

  {/* Text with style */}
  <Box textAlign="center" position="relative" zIndex={1}>
    <Text
      bgGradient="linear(to-r, #B67300, #FFD580)"
      bgClip="text"
      fontSize={{ base: "4xl", md: "6xl" }}
      fontWeight="extrabold"
      textTransform="uppercase"
      letterSpacing="wide"
    >
      About Us
    </Text>
    <Box
      mt={3}
      mx="auto"
      w="80px"
      h="3px"
      bg="#B67300"
      borderRadius="full"
    />
  </Box>
</Box>


      {/* Company Overview */}
      <MotionBox
        maxW="1000px"
        mx="auto"
        px={6}
        mb={20}
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Stack direction={["column", "row"]} spacing={10} align="center">
          <Image
            src="/contact (5).jpeg"
            alt="Company Overview"
            rounded="2xl"
            shadow="lg"
            w={["100%", "50%"]}
            h="350px"
            objectFit="cover"
          />
          <Box>
            <Heading size="xl" color="teal.600" mb={4}>
              Building Trust, Delivering Excellence
            </Heading>
            <Text fontSize="lg" color="gray.700" mb={4}>
              At <b> Lions Forge Contracting</b>, we take pride in being one of the
              most trusted names in construction, renovation, and facility
              management services. With years of experience and a skilled
              workforce, we ensure that every project is completed with
              precision, safety, and a commitment to quality.
            </Text>
            <Text fontSize="lg" color="gray.600" mb={4}>
              Our mission is simple — to provide exceptional services that exceed
              client expectations while maintaining transparency, reliability,
              and innovation at every step.
            </Text>
          </Box>
        </Stack>
      </MotionBox>

      {/* Mission / Vision / Values */}
      <Box bg="white" py={20}>
        <Heading textAlign="center" mb={12} color="teal.600">
          Our Mission, Vision & Values
        </Heading>
        <SimpleGrid columns={[1, 3]} spacing={10} maxW="1100px" mx="auto" px={6}>
          <Box p={6} shadow="md" rounded="xl" bg="gray.50">
            <Heading size="md" mb={3} color="teal.500">
              Mission
            </Heading>
            <Text>
              To deliver high-quality, cost-effective services on schedule by
              employing and supporting motivated, flexible, and focused teams.
            </Text>
          </Box>
          <Box p={6} shadow="md" rounded="xl" bg="gray.50">
            <Heading size="md" mb={3} color="teal.500">
              Vision
            </Heading>
            <Text>
              To be recognized as a leading contracting company that consistently
              delivers excellence and innovation across every project we handle.
            </Text>
          </Box>
          <Box p={6} shadow="md" rounded="xl" bg="gray.50">
            <Heading size="md" mb={3} color="teal.500">
              Values
            </Heading>
            <Text>
              Integrity, professionalism, teamwork, and a commitment to customer
              satisfaction form the foundation of everything we do.
            </Text>
          </Box>
        </SimpleGrid>
      </Box>

      {/* Why Choose Us */}
      <Box bg="gray.100" py={20}>
      <Grid
        templateColumns={{ base: "1fr", md: "1fr 1fr" }}
        gap={10}
        maxW="1100px"
        mx="auto"
        px={6}
        alignItems="center"
      >
        {/* Left Side - Text */}
        <GridItem>
          <Heading mb={8} color="teal.600">
            Why Choose  Lions Forge Contracting?
          </Heading>
          <VStack spacing={4} align="start">
            <Text> Experienced and skilled workforce</Text>
            <Text> End-to-end contracting & facility management solutions</Text>
            <Text> Commitment to quality and safety standards</Text>
            <Text> Transparent communication and reliable delivery</Text>
            <Text> Customized services to meet client needs</Text>
          </VStack>
        </GridItem>

        {/* Right Side - Motion Image */}
        <GridItem textAlign="center">
          <MotionImage

             src="/contact (3).jpeg"
        
            alt="Why Choose Us"
            rounded="2xl"
            shadow="lg"
            w="100%"
            h="350px"
            objectFit="cover"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          />
        </GridItem>
      </Grid>
    </Box>

      {/* Team / Experience Highlight */}
      <Box py={20}>
        <Stack
          direction={["column", "row"]}
          spacing={10}
          align="center"
          maxW="1100px"
          mx="auto"
          px={6}
        >
          <Image
             src="/contact (4).jpeg"
             alt="Our Team"
            rounded="2xl"
            shadow="lg"
            w={["100%", "50%"]}
            h="350px"
            objectFit="cover"
          />
          <Box>
            <Heading size="lg" mb={4} color="teal.600">
              Our Expertise
            </Heading>
            <Text fontSize="lg" color="gray.700" mb={4}>
              With a team of dedicated professionals,  Lions Forge Contracting has
              successfully completed numerous projects across construction,
              renovation, cleaning, and manpower supply. Our proven track record
              is a reflection of the trust clients place in us.
            </Text>
          </Box>
        </Stack>
      </Box>

      {/* Call to Action */}
      <Box textAlign="center" py={20} bg="teal.600" color="white">
        <Heading mb={4}>Let’s Build Something Great Together</Heading>
        <Text mb={6}>
          Partner with  Lions Forge Contracting for reliable, high-quality, and
          professional services tailored to your needs.
        </Text>
        <Button onClick={()=>navigate('/contact')} colorScheme="whiteAlpha" size="lg">
          Contact Us Today
        </Button>
      </Box>
    </Box>
  );
};
